import type { CustomerRegistrationResponseFragment } from '@/graphql/api'
import { useRouterNavigation } from '@/plugins/released-urls/useRouterNavigation'
import { useAuth } from '@/plugins/auth.ts'
import { useRouter } from 'vue-router'
import { useRegionPlugin } from '@/plugins/region'

export type ResponseData = {
    customer?: CustomerRegistrationResponseFragment
}

interface HandleFormSubmitResponse {
    handleFormSubmitResponse(data: ResponseData, redirect?: string | null): void
}

export function useHandleFormSubmitResponse(
    redirectToRoute: string
): HandleFormSubmitResponse {
    const { setAuth, setLoginMessage } = useAuth()
    const { routerPush } = useRouterNavigation()
    const router = useRouter()
    const { regionCode } = useRegionPlugin()

    const handleFormSubmitResponse = (
        data: ResponseData,
        redirect?: string | null
    ) => {
        if (data.customer) {
            setAuth(data.customer.login)
        } else {
            // TODO Translate
            setLoginMessage(
                "We've added this enquiry to your existing account."
            )
        }

        if (redirect) {
            const route = router.resolve(redirect)

            route.params['region'] = regionCode.value
            routerPush(route).catch(() => {})
        } else {
            routerPush({ name: redirectToRoute }).catch(() => {})
        }
    }

    return { handleFormSubmitResponse }
}
